import React from "react";
import "./Checkbox.scss";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../../config/mixpanelEvents";

interface ICheckboxProps {
  checked: boolean; // true if checkbox is checked, else false
  id?: string;
  name: string; // name for input checkbox
  disabled?: boolean; // if disabled then pass true
  required?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void; // function to be called on change
  children?: React.ReactNode
  legend?: string;
  ariaLabel?: string;
}

interface IMultiSelectCheckBoxProps {
  list: Array<{
    OptionDescription: string;
    QuestionID: number;
    OptionId: number;
    checked: boolean;
    disabled?: boolean;
  }>;
  disabled?: boolean; // if disabled then pass true
  onChange: (
    list: Array<{
      OptionDescription: string;
      QuestionID: number;
      OptionId: number;
      checked: boolean;
      disabled?: boolean;
    }>
  ) => void; // function to be called on change
  legend?: string;
}

function trackFormClicked(checkboxText: string | undefined, checked: boolean) {
  try {
    const screen_name = getScreenName(window.location.pathname);
    if (screen_name) {
      mixpanelService({
        event: mixpanelEvents.FORM_CLICKED,
        screen_name,
        checkbox_text: checkboxText,
        checkbox_state: checked,
      });
    }
  } catch (e) {
    console.error("mixpanel form_clicked failed", e);
  }
}

const Checkbox: React.FC<ICheckboxProps> = (props) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checkboxText =
      typeof props.children === "string" ? props.children : props.ariaLabel || props.name;
    trackFormClicked(checkboxText, event.target.checked);
    props.onChange(event);
  };

  return (
    <label className={"checkbox" + (props.disabled ? " disabled" : "")} htmlFor={props.id}>
      <input
        type="checkbox"
        id={props.id}
        onChange={handleChange}
        checked={props.checked || false}
        name={props.name}
        required={props.required || undefined}
        aria-required={props.required ? true : undefined}
        aria-label={props.children ? undefined : props.ariaLabel}
      />
      <span className="checked edel-icon-tick" aria-hidden="true"></span>
      {props.children && (
        <span className="checkbox_label">{props.children}</span>
      )}
    </label>
  );
};

export const MultiSelectCheckBox: React.FC<IMultiSelectCheckBoxProps> = (
  props
) => {
  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    trackFormClicked(event.target.name, event.target.checked);
    let updatedList: typeof props.list = props.list.map((checkbox) => {
      if (checkbox.OptionDescription === event.target.name) {
        return {
          OptionDescription: checkbox.OptionDescription,
          QuestionID: checkbox.QuestionID,
          OptionId: checkbox.OptionId,
          checked: event.target.checked,
        };
      }
      return checkbox;
    });
    props.onChange(updatedList);
  }

  return (
    <fieldset className="multiSelectFieldset">
      {props.legend && <legend className="sr-only">{props.legend}</legend>}
      {!props.legend && <legend className="sr-only">Select options</legend>}
      {props.list.map((checkbox) => (
        <label
          key={checkbox.OptionDescription}
          className={
            "checkbox multiSelect" +
            (props.disabled || checkbox.disabled ? " disabled" : "")
          }
        >
          <input
            type="checkbox"
            onChange={onChange}
            checked={checkbox.checked || false}
            name={checkbox.OptionDescription}
            disabled={props.disabled || checkbox.disabled}
          />
          <span className="checked edel-icon-tick" aria-hidden="true"></span>
          {checkbox.OptionDescription && (
            <span className="checkbox_label">{checkbox.OptionDescription}</span>
          )}
        </label>
      ))}
    </fieldset>
  );
};

export default Checkbox;
